import {Term} from '../../terms/components/TermsComponent';

export const childrenPrivacy: Term[] = [
  {
    id: '16.1',
    term:
      'If you are a parent or guardian and you are aware that your child has provided us with Personal Data without your consent, please contact us. If we become aware that we have collected Personal Data from children without parental consent, we take steps to remove that information from our servers.',
  },
];
